import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  // Force a deterministic light, high-contrast toast. Previously the toast
  // followed the device theme and clashed with the app's light tokens,
  // producing near-invisible white-on-white text on the dark storefront.
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        style: {
          background: "#ffffff",
          color: "#0f172a",
          border: "1px solid rgba(15, 23, 42, 0.12)",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.18)",
        },
        classNames: {
          title: "group-[.toast]:text-slate-900 group-[.toast]:font-semibold",
          description: "group-[.toast]:text-slate-600",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
